import { RRule } from 'rrule';
import { invert } from 'lodash';
import { t } from '../../../../../modules/infra/i18n';

const membershipBillingFrequency = {
  daily: new RRule({ freq: RRule.DAILY }).toString(),
  monthly: new RRule({ freq: RRule.MONTHLY }).toString(),
  quarterly: new RRule({ freq: RRule.MONTHLY, interval: 3 }).toString(),
  semiannually: new RRule({ freq: RRule.MONTHLY, interval: 6 }).toString(),
  annually: new RRule({ freq: RRule.YEARLY }).toString(),
};

const billingFrequencyI18nKeys = {
  daily: 'register:membership.billing_frequency.daily',
  monthly: 'register:membership.billing_frequency.monthly',
  quarterly: 'register:membership.billing_frequency.quarterly',
  semiannually: 'register:membership.billing_frequency.semiannually',
  annually: 'register:membership.billing_frequency.annually',
};

export const humanizeMembershipBillingFreq = (rruleBillingCycle) => {
  const frequencyKey = invert(membershipBillingFrequency)[rruleBillingCycle];
  if (frequencyKey && billingFrequencyI18nKeys[frequencyKey]) {
    return t(billingFrequencyI18nKeys[frequencyKey]);
  }
  return frequencyKey || rruleBillingCycle;
};

export default membershipBillingFrequency;
